export const reRegionsConstants = {
  SEND_REREGIONS_REQUEST: 'SEND_REREGIONS_REQUEST',
  SEND_REREGIONS_SUCCESS: 'SEND_REREGIONS_SUCCESS',
  SEND_REREGIONS_FAILURE: 'SEND_REREGIONS_FAILURE',
  CLEAR_REREGIONS: 'CLEAR_REREGIONS'
}